import { render, staticRenderFns } from "./competency-map.vue?vue&type=template&id=0046a8be"
import script from "./competency-map.ts?vue&type=script&lang=ts&external"
export * from "./competency-map.ts?vue&type=script&lang=ts&external"
import style0 from "./competency-map.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports